import Vue from 'vue'

const BYPASS_ROUTES = ['mainPage', 'notFound']

const ROLE_BASED_ALLOWED_ROUTES = {
  distribuidor: ['ItemIndex', 'ItemShow'],
  instalador:   ['ItemIndex', 'ItemShow'],
  atkAsesores:  ['CardTransactionIndex', 'ItemIndex', 'ItemShow', 'TicketIndex', 'TicketShow', 'ServiceCallIndex', 'ServiceCallShow', 'ServiceCallNew'],
}

function isAuthorized(role, routeName, userRoles) {
  if (userRoles.includes('ATK - asesores')) {
    return ROLE_BASED_ALLOWED_ROUTES.atkAsesores.includes(routeName)
  }
  return ROLE_BASED_ALLOWED_ROUTES[role]?.includes(routeName) ?? true
}

export function setupRouter(router, store, roles) {
  router.beforeEach(async (to, from, next) => {
    await Vue.nextTick()

    if (BYPASS_ROUTES.includes(to.name)) return next()

    const { prodOnly, distOnly, instOnly, prodActive } = to.meta
    const currentUserRole = store.state.currentUser.role

    if (currentUserRole === 'distribuidor') {
      if (!distOnly && !isAuthorized(currentUserRole, to.name, roles)) return next('/app/not_found')
    } else if (currentUserRole === 'instalador') {
      if (!instOnly && !isAuthorized(currentUserRole, to.name, roles)) return next('/app/not_found')
    } else if (distOnly || instOnly) {
      return next('/app/not_found')
    } else if (currentUserRole === 'non_prod' && prodOnly) {
      return next('/')
    } else if (currentUserRole === 'gerente' && prodActive) {
      // return next(error) // NOTE: original
      return next('/app/not_found')
    }

    next()
  })

  router.onError(() => {
    document
      .getElementById('content')
      ?.dispatchEvent(new Event('auth-denied'))
  })
}
